import { render } from "./SubscriptionPopup.vue?vue&type=template&id=48c34161&scoped=true"
import script from "./SubscriptionPopup.vue?vue&type=script&lang=js"
export * from "./SubscriptionPopup.vue?vue&type=script&lang=js"

import "./SubscriptionPopup.vue?vue&type=style&index=0&id=48c34161&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c34161"]])

export default __exports__